<div class="flex flex-col gap-4 m-5" style="max-height: 80vh; overflow: hidden;">
  <h2 class="text-xl font-semibold">
    Notifier les utilisateurs — {{ data.widgetName }}
  </h2>

  @if (store.loadingNotifications()) {
    <div class="text-center text-gray-500 py-4">Chargement...</div>
  } @else if (store.usersToBeNotified().length === 0) {
    <div class="text-center text-gray-500 py-4">Aucun utilisateur à notifier</div>
  } @else {
    <div style="overflow-y: auto; flex: 1 1 auto; min-height: 0;">
      <table mat-table [dataSource]="groupedUsers()" class="w-full">
        <ng-container matColumnDef="userDisplayName">
          <th mat-header-cell *matHeaderCellDef>Nom</th>
          <td mat-cell *matCellDef="let user">{{ user.userDisplayName }}</td>
        </ng-container>

        <ng-container matColumnDef="userMail">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let user">{{ user.userMail }}</td>
        </ng-container>

        <ng-container matColumnDef="contracts">
          <th mat-header-cell *matHeaderCellDef>Contrats</th>
          <td mat-cell *matCellDef="let user">{{ user.contracts }}</td>
        </ng-container>

        <ng-container matColumnDef="mailCount">
          <th mat-header-cell *matHeaderCellDef>Nombre de mails reçus</th>
          <td mat-cell *matCellDef="let user">{{ user.mailCount }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }

  <div class="flex flex-row gap-2 items-center justify-evenly mt-4">
    <button
      class="rounded-2xl bg-gray-100 text-black px-5 py-2 w-fit hover:bg-gray-200"
      (click)="cancel()"
    >
      Annuler
    </button>
    <button
      class="rounded-2xl bg-secondary text-white disabled:bg-secondary/40 px-5 py-2 w-fit"
      [disabled]="groupedUsers().length === 0 || store.sendingNotifications()"
      (click)="send()"
    >
      Envoyer
    </button>
  </div>
</div>
